import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: null,
        flags: {},
    },
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },

        logout: (state) => {
            state.token = null;
        },
        setFlags: (state, action) => {
            state.flags = action.payload;
        },
    },
});

export const { setToken, logout,setFlags } = authSlice.actions;
export default authSlice.reducer;
